import { CS } from "../../../base/utils/styler";

export const baseStyle:CS = {
    display: 'flex',    
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px',
    margin: '10px 0'
}